import {
  OreHeading,
  OreInput,
  OreSelect,
  OreSelectPlaceholder,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { Step1Form } from '@/AutoEnrollment/ui/hooks'
import { documentType } from '@/Shared/domain'
import { handleErrors } from '@/Shared/ui/form'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const Step1BillingOwnerData = (): JSX.Element => {
  const { t } = useTranslation()
  const formContext = useFormContext<Step1Form>()
  const { register, formState } = formContext
  const { errors } = handleErrors(formState)

  return (
    <OreStack placeContent="stretch" space="large">
      <OreHeading as="h2" size="headline-md">
        {t(AutoEnrollmentTranslation.billingOwnerData.title)}
      </OreHeading>
      <OreText>{t(AutoEnrollmentTranslation.billingOwnerData.description)}</OreText>
      <OreInput
        {...register('billingName')}
        {...errors('billingName')}
        id="billingName"
        label={t(AutoEnrollmentTranslation.billingOwnerData.data.name.label)}
        placeholder={t(AutoEnrollmentTranslation.billingOwnerData.data.name.placeholder)}
        required
        maxLength={20}
      />
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('billingSurname1')}
          {...errors('billingSurname1')}
          id="billingSurname1"
          label={t(AutoEnrollmentTranslation.billingOwnerData.data.surname1.label)}
          placeholder={t(
            AutoEnrollmentTranslation.billingOwnerData.data.surname1.placeholder,
          )}
          required
          maxLength={20}
        />
        <OreInput
          {...register('billingSurname2')}
          {...errors('billingSurname2')}
          id="billingSurname2"
          label={t(AutoEnrollmentTranslation.billingOwnerData.data.surname2.label)}
          placeholder={t(
            AutoEnrollmentTranslation.billingOwnerData.data.surname2.placeholder,
          )}
          maxLength={20}
        />
      </OreStack>
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreSelect
          {...register('documentType')}
          {...errors('documentType')}
          id="documentType"
          label={t(AutoEnrollmentTranslation.billingGeneralData.data.documentType.label)}
          legend={t(
            AutoEnrollmentTranslation.billingGeneralData.data.documentType.legend,
          )}
          required
        >
          <OreSelectPlaceholder
            label={t(
              AutoEnrollmentTranslation.billingGeneralData.data.documentType.placeholder,
            )}
          />
          <option value={documentType.DniNie}>
            {t(formTranslation.common.identifier.documentType.dni)}
          </option>
          <option value={documentType.Passport}>
            {t(formTranslation.common.identifier.documentType.passport)}
          </option>
        </OreSelect>
        <OreInput
          {...register('documentNumber')}
          {...errors('documentNumber')}
          id="documentNumber"
          label={t(
            AutoEnrollmentTranslation.billingGeneralData.data.documentNumber.label,
          )}
          placeholder={t(
            AutoEnrollmentTranslation.billingGeneralData.data.documentNumber.placeholder,
          )}
          required
          maxLength={14}
        />
      </OreStack>
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('billingEmail')}
          {...errors('billingEmail')}
          id="billingEmail"
          label={t(AutoEnrollmentTranslation.billingOwnerData.data.email.label)}
          type="email"
          placeholder={t(
            AutoEnrollmentTranslation.billingOwnerData.data.email.placeholder,
          )}
          labelTooltip={t(AutoEnrollmentTranslation.billingOwnerData.data.email.tooltip)}
          required
          maxLength={255}
        />
        <OreInput
          {...register('billingPhone')}
          {...errors('billingPhone')}
          id="billingPhone"
          label={t(AutoEnrollmentTranslation.billingOwnerData.data.phone.mobile.label)}
          type="tel"
          placeholder={t(
            AutoEnrollmentTranslation.billingOwnerData.data.phone.placeholder,
          )}
          labelTooltip={t(AutoEnrollmentTranslation.billingOwnerData.data.phone.tooltip)}
          required
          maxLength={255}
        />
      </OreStack>
    </OreStack>
  )
}
